import { StateCreator } from 'zustand';
import produce from 'immer';

interface userIds {
  id?: number;
  name?: string;
  email?: string;
  div?: string;
  isPm?: boolean;
  isCm?: boolean;
  isOp?: boolean;
  lecturer_srl?: string;
}

export interface IAuthSlice {
  login?: userIds;  
  loading: boolean;
  setMyInfo: (user: userIds) => void;
  setLoading: (val: boolean) => void;
  reset: () => void;
}

export interface IAuth {
  auth: IAuthSlice;
}

const initialState = {
  user: null,
  loading: false,
};

export const createAuthSlice: StateCreator<IAuthSlice> = (set) => ({
  ...initialState,
  setMyInfo(user) {
    set(
      produce((draft) => {
        draft.auth.login = { ...draft.auth.login, ...user };
      }),
    );
  },
  reset: async () => {
    set(
      produce((draft) => {
        draft.auth = { ...draft.auth, ...initialState };
      }),
    );
  },
  setLoading: (val) =>
    set(
      produce((draft) => {
        draft.auth.loading = val;
      }),
    ),
});
